/**
 * 詳細期間が選択されているか（必須チェック）。
 *
 * @param {number | string | null | undefined} detailPeriodKey
 * @returns {{ valid: boolean; message?: string }}
 */
export function validateDetailPeriodRequired(detailPeriodKey) {
  if (detailPeriodKey === null || detailPeriodKey === undefined || detailPeriodKey === '') {
    return { valid: false, message: '詳細期間を選択してください' }
  }
  return { valid: true }
}

/**
 * 設定済みの項目のみ / 未設定の項目のみ は排他。一方ONのとき他方をOFFにする。
 *
 * @param {boolean} checkedSet
 * @param {boolean} checkedUnset
 * @returns {{ checkedSet: boolean; checkedUnset: boolean }}
 */
export function validateFilterExclusive(checkedSet, checkedUnset) {
  if (checkedSet && checkedUnset) {
    return { checkedSet: true, checkedUnset: false }
  }
  return { checkedSet: !!checkedSet, checkedUnset: !!checkedUnset }
}
